import { render, staticRenderFns } from "./NewClientDialog.vue?vue&type=template&id=62fb38ac&"
import script from "./NewClientDialog.vue?vue&type=script&lang=js&"
export * from "./NewClientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewClientDialog.vue"
export default component.exports